export default __webpack_public_path__ + "static/media/xk.0d8bf5b9.svg";